// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

// AUT-6432: the pipeline the design draws - the order is being processed, the AI has produced
// a result, a human is checking its quality. How far along a project is (the step) and whether
// it is under way at all come from resolveProjectStatus / selectProjectInfo, the one reading
// every surface shares; this file only names the stages.
export type ProjectProgressPhase = 'Processing' | 'AI' | 'QC';

export const PROJECT_PROGRESS_STEPS: readonly ProjectProgressPhase[] = ['Processing', 'AI', 'QC'];

// The stage's name for the surfaces that say it in words instead of drawing it - the map rail's
// cards and the pin card. Takes the step resolveProjectStatus answers, so the words and the grid
// card's drawing can never disagree about where a project is. Step 0 is work that has not
// started: there is no stage to name.
export const nameProjectProgressStep = (step: 0 | 1 | 2 | 3): ProjectProgressPhase | null => (
  step === 0 ? null : PROJECT_PROGRESS_STEPS[step - 1]
);
